const DiagnosesStore = {
	data: {
		diagnoses: [
			{ 
				code: '0010',
				name: 'Cholera - Due to vibrio cholerae',
				shortName: 'Cholera - Due to vibrio cholerae',
				filterStatus: true,
			},
			{ 
				code: '0011',
				name: 'Cholera - Due to vibrio cholerae el tor',
				shortName: 'Cholera - Due to vibrio cholerae el tor',
				filterStatus: true,
			},
			{ 
				code: '0019',
				name: 'Cholera - Unspecified',
				shortName: 'Cholera - Unspecified',
				filterStatus: true,
			},
			{ 
				code: '0020',
				name: 'Typhoid and paratyphoid fevers - Typhoid fever',
				shortName: 'Typhoid fever',
				filterStatus: true,
			},
			{
				code: '0021',
				name: 'Typhoid and paratyphoid fevers - Paratyphoid fever A',
				shortName: 'Paratyphoid fever A',
				filterStatus: true,
			},
			{
				code: '0022',
				name: 'Typhoid and paratyphoid fevers - Paratyphoid fever B',
				shortName: 'Paratyphoid fever B',
				filterStatus: true,
			},
			{
				code: '0023',
				name: 'Typhoid and paratyphoid fevers - Paratyphoid fever C',
				shortName: 'Paratyphoid fever C',
				filterStatus: true,
			},
			{
				code: '0029',
				name: 'Typhoid and paratyphoid fevers - Paratyphoid fever',
				shortName: 'Paratyphoid fever',
				filterStatus: true,
			},
			{
				code: '0030',
				name: 'Other salmonella infections - Salmonella gastroenteritis',
				shortName: 'Salmonella gastroenteritis',
				filterStatus: true,
			},
			{
				code: '0031',
				name: 'Other salmonella infections - Salmonella septicaemia',
				shortName: 'Salmonella septicaemia',
				filterStatus: true,
			},
			{
				code: '0032',
				name: 'Other salmonella infections - Local salmonella infections',
				shortName: 'Local salmonella',
				filterStatus: true,
			},
			{
				code: '0038',
				name: 'Other salmonella infections - Other',
				shortName: 'Salmonella - Other',
				filterStatus: true,
			},
			{
				code: '0039',
				name: 'Other salmonella infections - Unspecified',
				shortName: 'Salmonella - Unspecified',
				filterStatus: true,
			},
			{
				code: '0040',
				name: 'Shigellosis - Shigella dysenteriae',
				shortName: 'Shigella dysenteriae',
				filterStatus: true,
			},
			{
				code: '0041',
				name: 'Shigellosis - Shigella flexneri',
				shortName: 'Shigella flexneri',
				filterStatus: true,
			},
			{
				code: '0042',
				name: 'Shigellosis - Shigella boydii',
				shortName: 'Shigella boydii',
				filterStatus: true,
			},
			{
				code: '0043',
				name: 'Shigellosis - Shigella soneii',
				shortName: 'Shigella soneii',
				filterStatus: true,
			},
			{
				code: '0048',
				name: 'Shigellosis - Other',
				shortName: 'Shigellosis - Other',
				filterStatus: true,
			},
			{
				code: '0049',
				name: 'Shigellosis - Unspecified',
				shortName: 'Shigellosis - Unspecified',
				filterStatus: true,
			},
			{
				code: '0050',
				name: 'Other food poisoning (bacterial) - Staphylococcal food poisoning',
				shortName: 'Staphylococcal',
				filterStatus: true,
			},
			{
				code: '0051',
				name: 'Other food poisoning (bacterial) - Botulism',
				shortName: 'Botulism',
				filterStatus: true,
			},
			{
				code: '0052',
				name: 'Other food poisoning (bacterial) - Food poisoning due to clostridium perfringens (CI.Welchii)',
				shortName: 'CI.Welchii',
				filterStatus: true,
			},
			{
				code: '0053',
				name: 'Other food poisoning (bacterial) - Food poisoning due to other clostridia',
				shortName: 'Other clostridia',
				filterStatus: true,
			},
			{
				code: '4334',
				name: 'Acute renal failure',
				shortName: 'Acute renal failure',
				filterStatus: true,
			},
			{
				code: '4340',
				name: 'Chronic renal failure',
				shortName: 'Chronic renal failure',
				filterStatus: true,
			},
			{
				code: '6440',
				name: 'Early or threatened labour - Threatended labour',
				shortName: 'Threatended labour',
				filterStatus: true,
			},
			{
				code: '6600',
				name: 'Obstructed labour - Obstruction caused my malposition of fetus at onset of labour',
				shortName: 'Obstructed - Malposition',
				filterStatus: true,
			},
			{
				code: '6601',
				name: 'Obstructed labour - Obstruction by bony pelvis',
				shortName: 'Obstructed - Bony pelvis',
				filterStatus: true,
			},
			{
				code: '6602',
				name: 'Obstructed labour - Obstruction by abnormal pelvic soft tissue',
				shortName: 'Obstructed - Pelvic soft tissue',
				filterStatus: true,
			},
			{
				code: '6606',
				name: 'Obstructed labour - Failed trial of labour',
				shortName: 'Obstructed - Failed trial',
				filterStatus: true,
			},
			{
				code: '35B',
				name: 'False labour',
				shortName: 'False labour',
				filterStatus: true,
			},
			{
				code: '0509',
				name: 'Smallpox',
				shortName: 'Smallpox',
				filterStatus: true,
			},
			{
				code: '0222',
				name: 'Anthrax - Gastrointestinal anthrax',
				shortName: 'Gastrointestinal anthrax',
				filterStatus: true,
			},
		]
	},
	methods: {
		getDiagnosis($code) {
			let $index = DiagnosesStore.data.diagnoses.findIndex(
				element => element.code == $code
			);

			return DiagnosesStore.data.diagnoses[$index];
		},
		setStatus($code, $status) {
			let $index = DiagnosesStore.data.diagnoses.findIndex(
				element => element.code == $code
			);

			DiagnosesStore.data.diagnoses[$index].filterStatus = $status;
		}
	}
};

export default DiagnosesStore;